// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* .modal-lg {\n    max-width: 85%!important;\n}\n\n.modal{\n    z-index: 999999;\n} */", "",{"version":3,"sources":["webpack://./resources/js/components/SocioDemografia/estilos.css"],"names":[],"mappings":"AAAA;;;;;;GAMG","sourcesContent":["/* .modal-lg {\n    max-width: 85%!important;\n}\n\n.modal{\n    z-index: 999999;\n} */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
